import React from 'react';
import './index.css';

import { fullpageApi } from "@fullpage/react-fullpage";
import ScrollDownBtn from "../../components/ScrollDownBtn";
import ScrollUpBtn from "../../components/ScrollUpBtn";
import { IRoofAddress } from "../../react-app-env";
import Counter, { formatNumber, getCounterScale } from "../../components/Counter";

interface P {
    sectionId?: string
    activePageId: string
    i18nMap: any
    fullpageApi: fullpageApi
    selectedDraft: IRoofAddress
    roofDrafts: IRoofAddress[]
}

const TeaserStep = ({ sectionId = 'step3', activePageId, i18nMap, fullpageApi, selectedDraft, roofDrafts, }: P) => {

    // Sum electricity production across all roofs of all drafts
    let calculatedCounter1: number = 0;
    roofDrafts.forEach(draft => {
        draft.roofs.forEach(roof => {
            if (roof.isCustom) {
                calculatedCounter1 += Math.round(roof.area * 14);
            } else if (roof.summerElectricityYield_kWh > 0 && roof.winterElectricityYield_kWh > 0) {
                calculatedCounter1 += Math.round((roof.summerElectricityYield_kWh + roof.winterElectricityYield_kWh) * 0.75);
            }
        });
    });

    const calculatedCounter2 = Math.round(calculatedCounter1 / 4500);
    const calculatedCounter3 = Math.round(calculatedCounter1 * 3.6);

    const teaserHeadingStr = String(i18nMap.teaserHeading || "");
    const words = teaserHeadingStr.split(' ');
    const lastWord = words.pop() || "";
    const firstPart = words.join(' ');

    const isActive: boolean = activePageId === sectionId;
    return (
        <div id={sectionId} className={`header header-roof section`}>
            <ScrollUpBtn onClick={() => fullpageApi.moveSectionUp()} label={i18nMap.backToRoofType} />

            <div className={`teaser-heading-wrapper`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 auto 1rem', width: '100%' }}>
                <div style={{ fontWeight: 200, fontSize: '1.2rem', textAlign: 'center' }}>
                    {firstPart}
                </div>
                <div className="sub-step-title" style={{ margin: 0, width: 'auto', fontSize: 'clamp(1.8rem, 6vw, 2.5rem)', justifyContent: 'center' }}>
                    <div className="sub-step-title-left" style={{ justifyContent: 'center' }}>
                        <span className="roof-icon-label" style={{ fontSize: '1.5rem' }}><i className="fa fa-sun-o" /></span>
                        <span style={{ fontWeight: 600 }}>{lastWord}</span>
                    </div>
                </div>
            </div>

            <div className={`teasers`}>

                <div className={`teaser-counter`}>

                    <div className={`counter-value-holder`}>
                        <i className="fa fa-thin fa-bolt counter-bg"></i>
                        {isActive ? <Counter target={calculatedCounter1} /> :
                            <div className={`counter-value`} style={{ '--counter-scale': getCounterScale(calculatedCounter1) } as React.CSSProperties}>{formatNumber(calculatedCounter1)}</div>}
                        <div className={`counter-unit`}>{i18nMap.electricityProductionPerYearUnit}</div>
                    </div>

                    <div className={`counter-title`}>{i18nMap.electricityProductionPerYear}</div>

                </div>

                <div className={`teaser-counter`}>
                    <div className={`counter-value-holder`}>

                        <i className="fa fa-thin fa-home counter-bg"></i>
                        {isActive ? <Counter target={calculatedCounter2} /> :
                            <div className={`counter-value`} style={{ '--counter-scale': getCounterScale(calculatedCounter2) } as React.CSSProperties}>{formatNumber(calculatedCounter2)}</div>}

                    </div>


                    <div className={`counter-title`}>{i18nMap.amountOfHouseholds}</div>
                </div>

                <div className={`teaser-counter`}>


                    <div className={`counter-value-holder`}>
                        <i className="fa fa-thin fa-dollar counter-bg"></i>
                        <div className={`counter-unit`} style={{ alignSelf: "center" }}>{i18nMap.financialReturnIn30yearsUnit}</div>
                        {isActive ? <Counter target={calculatedCounter3} /> :
                            <div className={`counter-value`} style={{ '--counter-scale': getCounterScale(calculatedCounter3) } as React.CSSProperties}>{formatNumber(calculatedCounter3)}</div>}

                    </div>

                    <div className={`counter-title`}>{i18nMap.financialReturnIn30years}</div>
                </div>
            </div>

            <p className={`teaser-subheading`} style={{ textAlign: 'center' }}>{i18nMap.teaserSubheading}</p>

            <ScrollDownBtn onClick={() => fullpageApi.moveSectionDown()} label={i18nMap.nextToOfferings} />
        </div>
    );
}

export default TeaserStep;